const FaceoffEvent = ({ event, getPlayerName, getTeamAbbreviation, homeTeamId, awayTeamId }) => {
    const winningPlayerId = event.details?.winningPlayerId;
    const losingPlayerId = event.details?.losingPlayerId;
    const winningPlayerName = getPlayerName(winningPlayerId);
    const losingPlayerName = getPlayerName(losingPlayerId);
    const winningPlayerTeamId = event.details?.eventOwnerTeamId;
    const losingPlayerTeamId = winningPlayerTeamId === homeTeamId ? awayTeamId : homeTeamId;
    const winningPlayerTeamAbbrev = getTeamAbbreviation(winningPlayerTeamId);
    const losingPlayerTeamAbbrev = getTeamAbbreviation(losingPlayerTeamId);
    const winningPlayerMugshotUrl = winningPlayerId ? `https://assets.nhle.com/mugs/nhl/20242025/${winningPlayerTeamAbbrev}/${winningPlayerId}.png` : null;
    const losingPlayerMugshotUrl = losingPlayerId ? `https://assets.nhle.com/mugs/nhl/20242025/${losingPlayerTeamAbbrev}/${losingPlayerId}.png` : null;

    return (
        <div className="flex items-center mb-2">
            <span className="text-sm font-semibold text-gray-700 mr-2">Time:</span>
            <span className="text-sm text-gray-900 mr-2">{event.timeInPeriod}</span>
            <span className="text-sm font-semibold text-gray-700 mr-2">Period:</span>
            <span className="text-sm text-gray-900 mr-2">{event.periodDescriptor.number}</span>
            <span className="text-sm font-semibold text-gray-700 mr-2">{winningPlayerName}</span>
            {winningPlayerMugshotUrl && (
                <img
                    src={winningPlayerMugshotUrl}
                    alt={winningPlayerName}
                    className="inline-block ml-2 w-8 h-8 rounded-full"
                />
            )}
            <span className="text-sm font-semibold text-gray-700 mx-2">Wins Faceoff against</span>
            {losingPlayerMugshotUrl && (
                <img
                    src={losingPlayerMugshotUrl}
                    alt={losingPlayerName}
                    className="inline-block ml-2 w-8 h-8 rounded-full"
                />
            )}
            <span className="text-sm font-semibold text-gray-700 ml-2">{losingPlayerName}</span>
        </div>
    );
};

export default FaceoffEvent;
